/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Trainee7Inputs */

const en_job_form_enum_trainee7 = /** @type {(inputs: Job_Form_Enum_Trainee7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainee`)
};

const de_job_form_enum_trainee7 = /** @type {(inputs: Job_Form_Enum_Trainee7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainee`)
};

/**
* | output |
* | --- |
* | "Trainee" |
*
* @param {Job_Form_Enum_Trainee7Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_trainee7 = /** @type {((inputs?: Job_Form_Enum_Trainee7Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Trainee7Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_trainee7(inputs)
	return en_job_form_enum_trainee7(inputs)
});
export { job_form_enum_trainee7 as "job_form_enum_TRAINEE" }